// Function to fill the form with provided data
export const fillForm = (form) => {
  return {
    id: form?.id,
    Link: form.link,
    Title: form.title,
    Image: form?.image,
    imageFullUrl: form.imageFullUrl,
  };
};
